// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommentCreateEditForm_Form__QvcqY {
    border: none;
    border-bottom: 2px #00d1ff solid;
  }
  
  .CommentCreateEditForm_Button__Q6E4k {
    border: none;
    background-color: #282e42;
    color: rgb(233, 240, 247);
    border-radius: 80px;
    padding: 4px 10px;
    min-width: 65px;
    margin: 5px;
  }
  
  .CommentCreateEditForm_Button__Q6E4k:hover {
    cursor: pointer;
    background-color: #051031;
    color: #fff;
  }`, "",{"version":3,"sources":["webpack://./src/styles/CommentCreateEditForm.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,WAAW;EACb","sourcesContent":[".Form {\n    border: none;\n    border-bottom: 2px #00d1ff solid;\n  }\n  \n  .Button {\n    border: none;\n    background-color: #282e42;\n    color: rgb(233, 240, 247);\n    border-radius: 80px;\n    padding: 4px 10px;\n    min-width: 65px;\n    margin: 5px;\n  }\n  \n  .Button:hover {\n    cursor: pointer;\n    background-color: #051031;\n    color: #fff;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Form": `CommentCreateEditForm_Form__QvcqY`,
	"Button": `CommentCreateEditForm_Button__Q6E4k`
};
export default ___CSS_LOADER_EXPORT___;
